import { useCallback, useEffect, useState } from 'react';
import { clearSession, getSession, portalApi, type PortalSession } from '@/api/portal';

export function useAuth() {
  const [session, setSession] = useState<PortalSession | null>(() => getSession());

  useEffect(() => {
    setSession(getSession());
  }, []);

  const signIn = useCallback(async (merchantNo: string, password: string, verifyKey: string, verifyCode: string) => {
    const next = await portalApi.login(merchantNo, password, verifyKey, verifyCode);
    setSession(next);
    return next;
  }, []);

  const signOut = useCallback(() => {
    clearSession();
    setSession(null);
  }, []);

  return {
    session,
    user: session,
    loading: false,
    initialized: true,
    signIn,
    signOut,
  };
}
